import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { BRAND } from "@/lib/brand";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock, Mail } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function Pending() {
  return (
    <div className="relative min-h-screen aurora grain flex items-center justify-center p-6">
      <ThemeToggle className="absolute top-4 right-4 z-10" />
      <Card className="relative w-full max-w-lg rounded-2xl p-8 sm:p-10 text-center ring-1 ring-black/5 dark:ring-white/10 glass">
        <div className="mx-auto size-14 rounded-2xl bg-brand/10 flex items-center justify-center text-brand">
          <Clock className="size-7" />
        </div>
        <h1 className="mt-6 font-display text-2xl font-semibold tracking-tight">Your request is under review</h1>
        <p className="mt-3 text-muted-foreground leading-relaxed">
          Thanks for signing up. Our team reviews every new account before granting portal access. You'll be notified by email once you're approved — typically within one business day.
        </p>
        <div className="mt-6 rounded-xl bg-white/70 dark:bg-white/5 ring-1 ring-black/5 dark:ring-white/10 p-4 flex items-center gap-3 text-left">
          <Mail className="size-5 text-brand shrink-0" />
          <p className="text-sm text-muted-foreground">Questions? Email <span className="text-foreground font-medium">{BRAND.accessEmail}</span> and we'll help you get set up.</p>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/login"><Button variant="outline" className="rounded-xl w-full sm:w-auto">Back to login</Button></Link>
          <Link to="/"><Button variant="ghost" className="rounded-xl w-full sm:w-auto">Return home</Button></Link>
        </div>
        <div className="mt-8 flex justify-center"><Logo /></div>
      </Card>
    </div>
  );
}
